/**
 * Managing state without using Vuex
 */
import Vue from 'vue';

const state = {
    locations       : [],
    featuredLocation: null,

    searchType  : 'locations',
    distancePref: 'mi',
    awayText    : 'away',

    isLoading                      : false,
    useApi                         : true,
    allowCalculatingPostalCode     : true,
    calculatingPostalCode          : false,
    disableSearchButton            : true,
    showVirtualFittingWithNoResults: true,
    showFeaturedOnMobile           : false,

    showSearchForm : true,
    hasSearched    : false,
    showMapOnMobile: false,

    buttons: {
        events   : true,
        locations: true,
        retailers: true,
    },    

    imagePath: '',
    
    appRegion       : 'us',
    countryCode     : 'US',
    searchPostalCode: '',
    searchDistance  : '25',

    mapCenter: {
        default: {
            lat: 37.09024, 
            lng: -100.712891
        }
    }
};

export default Vue.observable(state);
